import styled from 'styled-components';
import UnitSwitch from '../../components/unitSwitch/UnitSwitch';
import { useEffect, useState } from 'react';
import LoanInfoService from '../../../service/LoanInfo';
import ListContent, { ListData } from './ListContent';

interface DataProps {
  complex_name: string;
  legal_address: string;
  road_address: string;
  area: string;
  max_floors: number;
  household_cnt: number;
  building_cnt: number;
  management_office_contact: string;
  builder: string;
  approval_date: string;
  heating_type: string;
  far_rate: number;
  bcr_rate: number;
  total_parking_cnt: number;
  parking_ratio: number;
}
interface Iprops {
  type: string;
  idx: number;
  setLinkSet?: (link: any) => void;
}

const AptComplexInfo = ({ type, idx, setLinkSet }: Iprops) => {
  const [unit, setUnit] = useState<'m' | '평'>('평');
  const [data, setData] = useState<DataProps>();

  const getAptComplexInfo = async () => {
    try {
      const res = await LoanInfoService.complexInfo(type, idx);
      setData(res.data);
      if (setLinkSet) {
        setLinkSet((prev: any) => ({
          ...prev,
          naverComplexLink: res.data.naverComplexLink,
        }));
      }
    } catch (error) {
      console.error('getAptComplexInfo 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (idx !== 0) {
      getAptComplexInfo();
    }
  }, []);

  const formatArea = (area: string, unit: string) => {
    const areas = area.split(',');
    return areas
      .map((value) => {
        const numericValue = parseFloat(value.replace('㎡', '').trim());

        if (unit === '평') {
          return (numericValue / 3.3).toFixed(2) + ' 평';
        } else {
          return numericValue.toFixed(2) + '㎡';
        }
      })
      .join(', ');
  };

  if (!data) return null;

  const AptData: ListData[] = [
    {
      label: '지번주소',
      value: data.legal_address,
      isAddress: true,
    },
    {
      label: '도로명주소',
      value: data.road_address,
      isAddress: true,
    },
    {
      label: '면적(전용)',
      value: formatArea(data.area, unit),
      hasToggleButton: true,
      unitItem: unit,
      setUnitItem: setUnit,
    },
    {
      label: '층수',
      value: `${data.max_floors}층`,
    },
    {
      label: '세대수',
      value: `${data.household_cnt}세대 (총${data.building_cnt}개동)`,
    },
    {
      label: '관리 사무소',
      value: data.management_office_contact.replace(
        /^(02|\d{3})(\d{3,4})(\d{4})$/,
        '$1-$2-$3',
      ),
    },
    {
      label: '건설사',
      value: data.builder,
    },
    {
      label: '사용 승인일',
      value: data.approval_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3'),
    },
    {
      label: '난방',
      value: data.heating_type,
    },
    {
      label: '용적률',
      value: `${data.far_rate}%`,
    },
    {
      label: '건폐율',
      value: `${data.bcr_rate}%`,
    },
    {
      label: '총주차대수',
      value: `${data.total_parking_cnt}대 (세대당${data.parking_ratio}대)`,
    },
  ];

  return (
    <Container id="단지정보">
      <ContentTitleBox>
        단지정보
        <AptName>{data?.complex_name}</AptName>
      </ContentTitleBox>
      <ListContent data={AptData} />
    </Container>
  );
};

export default AptComplexInfo;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px 16px;
  background: #ffffff;
  gap: 16px;
`;

const ContentTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
`;

const AptName = styled.span`
  padding: 2px 8px;
  border-radius: 4px;
  background: #008aff0f;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
  width: fit-content;
`;
